interface WarehouseSceneProps {
  className?: string;
}

/**
 * Lightweight animated warehouse illustration (monoline racks + a driving
 * forklift + a moving conveyor line) built entirely from inline SVG/CSS so
 * the login page doesn't depend on any external video/GIF asset.
 */
export default function WarehouseScene({ className = '' }: WarehouseSceneProps) {
  return (
    <svg
      viewBox="0 0 440 170"
      className={className}
      role="img"
      aria-label="Animated illustration of warehouse racking and a forklift moving pallets"
    >
      {/* Ground line */}
      <line x1="8" y1="150" x2="432" y2="150" stroke="#ffffff" strokeOpacity="0.18" strokeWidth="1.5" />

      {/* Overhead conveyor belt */}
      <line
        x1="112" y1="40" x2="328" y2="40"
        stroke="#fbbf24" strokeOpacity="0.35" strokeWidth="3" strokeLinecap="round"
        strokeDasharray="7 7"
        className="warehouse-conveyor"
      />
      <rect x="150" y="30" width="20" height="14" rx="2" fill="#f59e0b" fillOpacity="0.8" />
      <rect x="245" y="30" width="20" height="14" rx="2" fill="#fbbf24" fillOpacity="0.7" />

      {/* Left rack */}
      <g stroke="#ffffff" strokeOpacity="0.28" strokeWidth="1.5">
        <line x1="30" y1="58" x2="30" y2="150" />
        <line x1="94" y1="58" x2="94" y2="150" />
        <line x1="26" y1="58" x2="98" y2="58" />
        <line x1="26" y1="86" x2="98" y2="86" />
        <line x1="26" y1="114" x2="98" y2="114" />
      </g>
      <rect x="36" y="64" width="20" height="16" rx="2" fill="#f59e0b" fillOpacity="0.85" />
      <rect x="66" y="64" width="18" height="16" rx="2" fill="#fbbf24" fillOpacity="0.55" />
      <rect x="36" y="92" width="18" height="16" rx="2" fill="#fbbf24" fillOpacity="0.6" />
      <rect x="68" y="120" width="20" height="16" rx="2" fill="#f59e0b" fillOpacity="0.85" />

      {/* Right rack */}
      <g stroke="#ffffff" strokeOpacity="0.28" strokeWidth="1.5">
        <line x1="346" y1="58" x2="346" y2="150" />
        <line x1="410" y1="58" x2="410" y2="150" />
        <line x1="342" y1="58" x2="414" y2="58" />
        <line x1="342" y1="86" x2="414" y2="86" />
        <line x1="342" y1="114" x2="414" y2="114" />
      </g>
      <rect x="352" y="64" width="18" height="16" rx="2" fill="#fbbf24" fillOpacity="0.6" />
      <rect x="380" y="92" width="20" height="16" rx="2" fill="#f59e0b" fillOpacity="0.85" />
      <rect x="352" y="120" width="18" height="16" rx="2" fill="#fbbf24" fillOpacity="0.55" />

      {/* Forklift (translates back and forth along the ground) */}
      <g className="warehouse-forklift">
        <g transform="translate(120,150)">
          {/* mast */}
          <line x1="30" y1="-58" x2="30" y2="-14" stroke="#ffffff" strokeOpacity="0.45" strokeWidth="2.5" />
          <line x1="36" y1="-58" x2="36" y2="-14" stroke="#ffffff" strokeOpacity="0.45" strokeWidth="2.5" />
          {/* carried pallet box, bobbing gently */}
          <rect x="14" y="-46" width="22" height="18" rx="2" fill="#fbbf24" className="warehouse-forklift-box" />
          {/* forks */}
          <line x1="14" y1="-14" x2="0" y2="-14" stroke="#ffffff" strokeOpacity="0.5" strokeWidth="2.5" />
          <line x1="14" y1="-8" x2="0" y2="-8" stroke="#ffffff" strokeOpacity="0.5" strokeWidth="2.5" />
          {/* body */}
          <rect x="8" y="-32" width="30" height="20" rx="3" fill="#1e3a5f" stroke="#ffffff" strokeOpacity="0.3" />
          {/* cabin */}
          <rect x="14" y="-44" width="16" height="14" rx="2" fill="#0f2036" stroke="#ffffff" strokeOpacity="0.3" />
          {/* wheels */}
          <circle cx="14" cy="-10" r="6" fill="#0a1628" stroke="#ffffff" strokeOpacity="0.35" strokeWidth="1.5" />
          <circle cx="34" cy="-10" r="6" fill="#0a1628" stroke="#ffffff" strokeOpacity="0.35" strokeWidth="1.5" />
        </g>
      </g>
    </svg>
  );
}
